// Funzione di appoggio (invariata) per calcolare la durata netta
import {CollectionClip} from "../../types/collectionTypes";

function calculateMergedDuration(cuts: {start: number, end: number}[]): number {
    if (cuts.length === 0) return 0;

    const sorted = [...cuts].sort((a, b) => a.start - b.start);
    let total = 0;
    let currentStart = sorted[0].start;
    let currentEnd = sorted[0].end;

    for (let i = 1; i < sorted.length; i++) {
        const nextCut = sorted[i];
        if (nextCut.start <= currentEnd) {
            currentEnd = Math.max(currentEnd, nextCut.end);
        } else {
            total += (currentEnd - currentStart);
            currentStart = nextCut.start;
            currentEnd = nextCut.end;
        }
    }
    total += (currentEnd - currentStart);

    return total;
}

export function getCardSelectionDuration(
    cards: CollectionClip[],
    maxDurationMinutes?: number
): { originalDuration: number; cutDuration: number; updatedCards: CollectionClip[] } {
    const cutsByEvent = new Map<string, {start: number, end: number}[]>();
    const updatedCards: CollectionClip[] = [];

    let originalDuration = 0;
    let cutDuration = 0;
    let limitReached = false;

    // Assumiamo che i cut siano in secondi. Se sono in millisecondi, usa * 60000
    const maxDurationSeconds = maxDurationMinutes ? maxDurationMinutes * 60 : Infinity;

    for (const card of cards) {
        // Se la card non ha evento, passiamo oltre ma la includiamo se non siamo oltre il limite
        if (!card.event || !card.event.id) {
            if (!limitReached) updatedCards.push(card);
            continue;
        }

        const eventId = card.event.id;
        const existingCuts = cutsByEvent.get(eventId) || [];

        // Estraiamo tutti i cut da questa card
        const newCuts: {start: number, end: number}[] = [];
        for (const moment of (card.key_moments || [])) {
            for (const cut of moment.cuts) {
                newCuts.push({ start: cut.start, end: cut.end });
            }
        }

        // Se non ci sono cut, ci comportiamo come se non ci fosse un evento
        if (newCuts.length === 0) {
            if (!limitReached) updatedCards.push(card);
            continue;
        }

        // Calcoliamo quanto tempo aggiunge questa card all'evento (tenendo conto degli overlap passati)
        const oldEventDuration = calculateMergedDuration(existingCuts);
        const combinedCuts = [...existingCuts, ...newCuts];
        const newEventDuration = calculateMergedDuration(combinedCuts);

        const addedDuration = newEventDuration - oldEventDuration;

        // 1. Aggiorniamo SEMPRE la durata originale complessiva e la memoria degli overlap
        originalDuration += addedDuration;
        cutsByEvent.set(eventId, combinedCuts);

        // 2. Se non abbiamo ancora superato il limite, valutiamo se la card ci sta
        if (!limitReached) {
            if (cutDuration + addedDuration > maxDurationSeconds) {
                // Raggiunto il limite: attiviamo il flag, questa e le successive non verranno incluse
                limitReached = true;
            } else {
                // Limite rispettato: aggiorniamo la durata tagliata e salviamo la card
                cutDuration += addedDuration;
                updatedCards.push(card);
            }
        }
    }

    return {
        originalDuration,
        cutDuration,
        updatedCards
    };
}